export default __webpack_public_path__ + "static/media/fpb31000.73419e12.png";